export default [
  {
    title: 'breadcrumb.liveBetting',
    route: 'live-betting',
    icon: 'TvIcon',
    resource: 'live-betting',
    action: 'read'
  }
];